export const credits = {
  "Corporate Board": [
          { staff_name: "Tsehai Alfred", title: "Editor in Chief" },
          { staff_name: "Manuela Moreyra", title: "Managing Editor" },
          { staff_name: "Melinda Yao", title: "Publisher" }
  ],
  "University News": [
    {
      "staff_name": "Spencer Davis",
      "title": "University News Editor"
    },
    {
      "staff_name": "Emily Pickering",
      "title": "University News Editor"
    },
    {
      "staff_name": "Joseph Zuloaga",
      "title": "Deputy News Editor"
    },
    {
      "staff_name": "Colette Carbonara",
      "title": "Deputy News Editor"
    },
    {
      "staff_name": "Nadia Knoblauch",
      "title": "Deputy News Editor"
    },
    {
      "staff_name": "Molly Bordoff",
      "title": "Deputy News Editor"
    },
    {
      "staff_name": "Pedro Meerbaum",
      "title": "Staff Writer"
    },
    {
      "staff_name": "Celine Chien",
      "title": "Staff Writer"
    },
    {
      "staff_name": "Theresa Cullen",
      "title": "Staff Writer"
    },
    {
      "staff_name": "Ashley Flores",
      "title": "Staff Writer"
    },
    {
      "staff_name": "Matt Luo",
      "title": "Staff Writer"
    },
    {
      "staff_name": "Sarah Huddleston",
      "title": "Former University News Editor"
    },
    {
      "staff_name": "Shea Vance",
      "title": "Former University News Editor"
    },
    {
      "staff_name": "Isha Banerjee",
      "title": "Former University News Editor"
    },
    {
      "staff_name": "Irie Sentner",
      "title": "Former University News Editor"
    },
    {
      "staff_name": "Esha Karam",
      "title": "Former Managing Editor"
    },
    {
      "staff_name": "Aleka Gomez-Sotomayor-Roel",
      "title": "Former Staff Writer"
    },
    {
      "staff_name": "Rebecca Massel",
      "title": "Former Staff Writer"
    },
    {
      "staff_name": "Sabrina Ticer-Wurr",
      "title": "Former Staff Writer"
    },
    {
      "staff_name": "Emily Forgash",
      "title": "Former Deputy News Editor"
    },
  ],
  "Engineering": [
     
      {
        "staff_name": "Julien Remy",
        "title": "Co-Head of Engineering"
      },
      {
        "staff_name": "Shriya Mani",
        "title": "Co-Head of Engineering"
      },
      {
        "staff_name": "Noel Negron",
        "title": "Engineering Manager"
      }
    ],
  "Copy": [
      {
        "staff_name": "Emily Spencer",
        "title": "Head Copy Editor"
      },
      {
        "staff_name": "Eli Trokenheim",
        "title": "Deputy Copy Editor"
      },
      {
        "staff_name": "Diego Carvajal Núñez",
        "title": "Deputy Copy Editor"
      },
      {
        "staff_name": "Vaishnavi Sirkay",
        "title": "Deputy Copy Editor"
      },
      {
        "staff_name": "Elizabeth Kushelevsky",
        "title": "Deputy Copy Editor"
      },
      {
        "staff_name": "Gigi Chen",
        "title": "Deputy Copy Editor"
      },
      {
        "staff_name": "Eric Aguilar",
        "title": "Senior Associate Copy Editor"
      },
      {
        "staff_name": "Dalina Cao",
        "title": "Senior Associate Copy Editor"
      },
      {
        "staff_name": "Yoona Lee",
        "title": "Senior Associate Copy Editor"
      },
      {
        "staff_name": "Ames Yu",
        "title": "Senior Associate Copy Editor"
      },
      {
        "staff_name": "Sebastian Cunto-Araujo",
        "title": "Senior Associate Copy Editor"
      },
      {
        "staff_name": "Jordan Straub",
        "title": "Senior Associate Copy Editor"
      },
      {
        "staff_name": "Maxwell Gaynor",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Sreya Gupta",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Grace Mazer",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Kathleen Yang",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Finn Brown",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "June Liu",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Skerry Lu",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Serena Miles",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Claire Murray",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Kelly Sung",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Lynn Tang",
        "title": "Associate Copy Editor"
      },
      {
        "staff_name": "Posey Chiddix",
        "title": "Former Head Copy Editor"
      },
    ],
    "Product":[
    {
      "staff_name": "Eugene Kim",
      "title": "Head of Product"
    },
    {
      "staff_name": "Daniela Velazquez",
      "title": "Senior Product Designer"
    },
    
  ],
    "Photo": [
      {
        "staff_name": "Zohar Ford",
        "title": "Deputy Photo Editor",
      }
    ]
  // "Engagement": [
  //     {
  //       "staff_name": "Arielle Rieder",
  //       "title": "Engagement Director"
  //     },
  //     {
  //       "staff_name": "El Chu",
  //       "title": "Engagement Manager"
  //     }
  //   ],
  //   "Audio": [
  //     {
  //       "staff_name": "Eesha Ramanathan",
  //       "title": "Audio Editor"
  //     },
  //   ],
    
};